import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme?.spacing ? theme.spacing(3) : 24,
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  status: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: theme?.spacing ? theme.spacing(1) : 8,
    marginBottom: theme?.spacing ? theme.spacing(1) : 8,
  },

  title: {
    fontWeight: 600,
    fontSize: '1rem',
  },

  subtitle: {
    color: '#666',
    fontSize: '0.9rem',
  },

  logCard: {
    marginBottom: theme?.spacing ? theme.spacing(2) : 16,
  },

  sectionTitle: {
    marginTop: theme?.spacing ? theme.spacing(4) : 32,
    marginBottom: theme?.spacing ? theme.spacing(1) : 8,
  },

  summaryCard: {
    minHeight: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  summaryTitle: {
    fontSize: '1rem',
    color: '#555',
  },

  summaryValue: {
    fontSize: '2rem',
    fontWeight: 600,
  },
  chipSuccess: {
    backgroundColor: '#17d32d', 
    color: '#fff',
    fontWeight: 600,
  },
  chipConclusion: {
    backgroundColor: '#2bc62b', 
    color: '#fff',
    fontWeight: 600,
  },
  chipEnrollment: {
    backgroundColor: '#F53C56', 
    color: '#fff',
    fontWeight: 600,
  },
  chipExam: {
    backgroundColor: '#FF5733', 
    color: '#fff',
    fontWeight: 600,
  },
  chipProgress: {
    backgroundColor: '#3b82f6', 
    color: '#fff',
    fontWeight: 600,
  },
  chipLogin: {
    backgroundColor: '#2DCE98', 
    color: '#fff',
    fontWeight: 600,
  },

  blueIcon: {
    backgroundColor: '#176AE6 !important',
  },

  chipError: {
    backgroundColor: '#FFCDD2', 
  },
  chipInfo: {
    backgroundColor: '#BBDEFB', 
  },
}));
